import { create } from 'zustand';

type State = {
  attachmentList: AttachmentT[];
  selectedAttachment: AttachmentT | null;
};

type Action = {
  setAttachmentList: (attachmentList: AttachmentT[]) => void;
  setSelectedAttachment: (attachment: AttachmentT | null) => void;
  initAttachemntStore: () => void;
};

const initialState: State = {
  attachmentList: [],
  selectedAttachment: null,
};

const useAttachmentStore = create<State & Action>((set) => ({
  ...initialState,
  setAttachmentList: (attachmentList) => {
    set((state) => ({
      ...state,
      attachmentList,
    }));
  },
  setSelectedAttachment: (attachment) => {
    set((state) => ({
      ...state,
      selectedAttachment: attachment,
    }));
  },
  initAttachemntStore: () => {
    set(initialState);
  },
}));

export default useAttachmentStore;
